import React from "react";
import { FormattedMessage } from "react-intl";
import Box, { BoxProps } from "../box/Box";
import Heading from "../typography/Heading";
import Text from "../typography/Text";

interface IHighlightsProps {
  highlights: string[];
}

export default function Highlights({ highlights, ...props }: IHighlightsProps & BoxProps) {
  return (
    <Box border="1px" borderColor="gray.100" borderRadius="md" bg="teal.100" {...props}>
      <Box borderBottom="1px" borderColor="gray.100" py={3} px={8}>
        <Heading as="h2" color="gray.900" fontWeight="bold" fontSize="lg">
          <FormattedMessage defaultMessage="Highlights" id="KGmQjH" />
        </Heading>
      </Box>

      <Box css={{ padding: 16 }}>
        <ul
          css={{
            listStyle: "none",
            margin: 0,
            padding: 0,
            display: "grid",
            gridRowGap: 4,
          }}
        >
          {highlights.map((highlight, index) => (
            <li
              // eslint-disable-next-line
              key={index}
              css={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box mr={3} mt={1} display="inline-block" pr={5} width="13px" mb="auto">
                <Box width="10px" height="10px" bg="teal.600" borderRadius="full" />
              </Box>

              <Text wordBreak="break-word" color="black" fontSize="md" display="inline-block" m={0}>
                {highlight}
              </Text>
            </li>
          ))}
        </ul>
      </Box>
    </Box>
  );
}
